module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/header-image-mobile-05-acafbbca4cd7c2090d8654215e9cc9f9.jpg";